import { List } from "./styled";
import { SearchProfileCardSkeleton } from "./components";

const SKELETON_COUNT = 4;

export const SearchProfileSkeleton = () => (
  <List>
    {Array.from({ length: SKELETON_COUNT }).map((_, i) => (
      <SearchProfileCardSkeleton key={i} />
    ))}
  </List>
);
